import image5 from "../images/Construction-1.jpg";
import image6 from "../images/Construction-2.jpg";
import { useState } from "react";

const Construction = () => {
    const [block, setblock] = useState(false);

    function FullView(ImgLink){
        document.getElementById("FullImage3").src = ImgLink;
        setblock(true);
    }

    function CloseFullView(){
        setblock(false);
    }

    return ( 
        <>
            <div className="main-container">
                    <h2>Construction</h2>
                    <div className="components-section">
                        <div className="comp">
                            <div className="component">Civil Works</div>
                        </div>
                        <div className="comp">
                            <div className="component second">Maintenance</div>
                        </div>
                        <div className="comp">
                            <div className="component">Paving</div>
                        </div>
                        <div className="comp">
                            <div className="component second">Printing</div>
                        </div>
                        <div className="comp">
                            <div className="component">Fibre Optic</div>
                        </div>
                        
                    </div>
                    
                    <h3>Image Gallary </h3>
                    <h5>(Click image for fullscreen)</h5>
                    <div className="images">
                        <img src={image5} onClick={() => FullView(image5)} alt=""/>
                        <img src={image6} onClick={() => FullView(image6)} alt=""/>
                    </div>
                    <div className="fullImageView" style={{display: block? "block" : "none"}}>
                        <img id="FullImage3" alt=""  />
                        <i className="fa fa-times CloseButton" onClick={() => CloseFullView()}></i>
                    </div>
                </div>
                <div className="end-section3">
                </div>
            </>
     );
}

export default Construction;